import React, { useState, useRef } from 'react'
import DOMPurify from 'dompurify'
import * as Utils from '../../commons/utils/Utils.js'
import { FormattedMessage } from 'react-intl'

const PoliticaPrivacidadModal = (props) => {
	const politica = props.politica
	const [puedeAceptar, setPuedeAceptar] = useState(false)
	const [aceptando, setAceptando] = useState(false)
	const contenidoRef = useRef(null)

	const handleScroll = () => {
		var el = contenidoRef.current
		if (!el) return
		if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
			setPuedeAceptar(true)
		}
	}

	const handleAceptar = () => {
		setAceptando(true)
		Utils.sendData('/politicas-privacidad/' + politica.id + '/aceptar', 'POST', {})
			.then(function() {
				props.onAceptado()
			})
			.catch(function() {
				setAceptando(false)
			})
	}

	return (
		<div
			style={{
				position: 'fixed',
				top: 0, left: 0, right: 0, bottom: 0,
				zIndex: 9999,
				backgroundColor: 'rgba(0,0,0,0.6)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<div
				className="modal-dialog modal-lg"
				style={{ margin: 0, width: '100%', maxWidth: '760px' }}
			>
				<div className="modal-content">
					<div className="modal-header bg-fleet">
						<h4 className="modal-title text-white">
							{politica.titulo}
							<small className="ml-2" style={{ fontSize: '13px', opacity: 0.85 }}>
								v{politica.version}
							</small>
						</h4>
					</div>

					<div className="modal-body p-0">
						<div
							ref={contenidoRef}
							onScroll={handleScroll}
							style={{
								maxHeight: '55vh',
								overflowY: 'scroll',
								padding: '20px 24px',
								lineHeight: '1.7',
							}}
							dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(politica.contenido || '') }}
						/>
					</div>

					<div className="modal-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						{!puedeAceptar && (
							<small className="text-muted">
								<i className="fa fa-arrow-down mr-1"></i>
								<FormattedMessage
									id="politicasPrivacidad.scroll_para_aceptar"
									defaultMessage="Desplazate hasta el final para habilitar la aceptación"
								/>
							</small>
						)}
						{puedeAceptar && <span />}
						<button
							className="btn btn-primary"
							disabled={!puedeAceptar || aceptando}
							onClick={handleAceptar}
						>
							{aceptando
								? <span><i className="fa fa-spinner fa-spin mr-1"></i><FormattedMessage id="Procesando" defaultMessage="Procesando..." /></span>
								: <span><i className="fa fa-check mr-1"></i><FormattedMessage id="politicasPrivacidad.acepto" defaultMessage="Acepto la Política de Privacidad" /></span>
							}
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default PoliticaPrivacidadModal
